import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";

const config: LayoutConfigTypes = {
  themeName: "Metronic",
  themeVersion: "8.0.22",
  demo: "",
  main: {
    type: "default",
    primaryColor: "#009EF7",
    logo: {
      dark: "static/logo-biomas-grande-dark.png",
      light: "static/logo-biomas-grande.png",
      small: "static/logo-biomas-botella.png",
    },
  },
  loader: {
    logo: "static/logo-biomas-botella.png",
    display: true,
    type: "default",
  },
  scrollTop: {
    display: false,
  },
  header: {
    display: true,
    menuIcon: "font",
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: false,
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: "light",
    fixed: true,
    menuIcon: "svg",
    minimized: false,
    minimize: false,
    hoverable: false,
  },
  content: {
    width: "fixed",
  },
  footer: {
    width: "fluid",
  },
};

export default config;
